import {Stack, Typography} from '@mui/material';
import {
	AlertInfo,
	CTAButtonFixed,
	MainFooter,
	MainHeader,
	PageWrapperLayout,
	StyledGrid,
} from 'presentation/components';
import {AuthorizationsEnum, ExamBookingEnum, GuidesEnum} from 'presentation/constants';
import {useContractStatus, useHostName} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {ServiceCard} from 'presentation/pages/private/services/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {ppoNetworkTypeEnum} from 'presentation/modules/guide/shared/store/guideStore/types';
import {usePpoNetworkStore} from 'presentation/modules/guide/shared/store/guideStore/usePpoNetworkStore';
import {useNotredameNetworkItems} from 'presentation/pages/private/home/components/OptionsDrawer/hooks/useNotredameNetworkItems';
import {ServicesTypesEnum} from 'presentation/pages/private/services/types';
import {useOpenOptionsDrawerStore} from 'presentation/pages/private/store/useOpenOptionsDrawer';
import {CardInstructions} from '../../components/CardInstructions';
import {CardInstructionsVariantEnum} from '../../components/CardInstructions/types';
import {CustomCTAButtonFixedAction, StyledFooterContainer} from '../../styles';
import {StyledGridItem} from './styles';

const {title} = translations['pt-br'].privateFlow.requestAuthorizations;
const {textAlert} = translations['pt-br'].privateFlow.requestAuthorizations.newRequestInstructions;
const {shortcuts, bookExams, healthGuideAll, accreditedNetwork, proprietaryNetwork} =
	translations['pt-br'].privateFlow.services;
const {agreementText} = translations['pt-br'].commons;

export function NewRequestInstructions() {
	const navigate = useNavigate();
	const {isMobile} = useMediaQueries();
	const {isContractSuspended} = useContractStatus();
	const {isNotredameSaude} = useHostName();
	const {openOptionsDrawer} = useOpenOptionsDrawerStore();

	const setPpoNetworkType = usePpoNetworkStore(state => state.setPpoNetworkType);
	const {items: notredameNetworkItems} = useNotredameNetworkItems();

	const handleBack = () => {
		navigate(AuthorizationsEnum.AUTHORIZATIONS);
	};

	const handleGoToNetwork = () => {
		if (isNotredameSaude) setPpoNetworkType(ppoNetworkTypeEnum.ACCREDITED_NETWORK);

		navigate(GuidesEnum.SERVICE_NETWORK_HEALTH);
	};

	const handleGoToBookExams = () => {
		if (isNotredameSaude) {
			openOptionsDrawer(proprietaryNetwork, notredameNetworkItems);
			return;
		}

		navigate(ExamBookingEnum.EXAM_BOOKING_FLOW);
	};

	return (
		<PageWrapperLayout title={title}>
			<MainHeader
				variant="subRoute"
				title={title}
				handleBack={handleBack}
				handleClose={handleBack}
			/>
			<AlertInfo.Root sx={{borderRadius: 0}} severity="info">
				<AlertInfo.Description> {textAlert} </AlertInfo.Description>
			</AlertInfo.Root>

			<StyledGrid.Root px={isMobile ? 2 : 4} spacing={3} mt={1}>
				<StyledGridItem sm={12} md={8} lg={8} mt={isMobile ? 1 : 0} gap={3}>
					<CardInstructions variant={CardInstructionsVariantEnum.SMALL} />

					<CTAButtonFixed.Root
						direction={isMobile ? 'column' : 'row'}
						justifyContent={'end'}
						mt={2}>
						<CustomCTAButtonFixedAction
							data-tag-id={AutoSolEnum.CLICK_ENTENDI_INFOS_AUTOSOL}
							fullWidth={isMobile}
							onClick={() => navigate(AuthorizationsEnum.AUTHORIZATIONS)}
							size="large"
							variant="contained">
							{agreementText}
						</CustomCTAButtonFixedAction>
					</CTAButtonFixed.Root>
				</StyledGridItem>

				<StyledGrid.Item sm={12} md={4} lg={4}>
					<Stack spacing={1}>
						<Typography variant="subtitle2" color="text.secondary">
							{shortcuts}
						</Typography>

						<ServiceCard
							dataTagId={AutoSolEnum.CLICK_REDE_DE_ATENDIMENTO_AUTOSOL}
							icon="pin-drop-filled"
							title={isNotredameSaude ? accreditedNetwork : healthGuideAll}
							type={ServicesTypesEnum.OTHERS}
							routeReplace={false}
							handleClick={handleGoToNetwork}
						/>
						{!isContractSuspended ? (
							<ServiceCard
								dataTagId={AutoSolEnum.CLICK_AGENDAR_EXAME_AUTOSOL}
								icon={isNotredameSaude ? 'notredame-logo' : 'needle'}
								title={isNotredameSaude ? proprietaryNetwork : bookExams}
								type={ServicesTypesEnum.EXAMS}
								routeReplace={false}
								handleClick={handleGoToBookExams}
							/>
						) : null}
					</Stack>
				</StyledGrid.Item>
			</StyledGrid.Root>

			<StyledFooterContainer $mb={72}>
				<MainFooter />
			</StyledFooterContainer>
		</PageWrapperLayout>
	);
}
